// import { Dropdown, Button, Col } from 'antd';
// import type { MenuProps } from 'antd';
// import { useRegion } from '@/context/CountryContext';
// import { countryRegions } from '@/pages/amazon/accounts/Data/CountryRegions';
// import { useMemo } from 'react';

// const CountrySwitcher = () => {
//   const { selectedRegion, setSelectedRegion } = useRegion();


//   const countryDataMap: Record<string, any> = {};
//   countryRegions.forEach(region => {
//     region.countries.forEach(country => {
//       countryDataMap[country.countryCode] = {
//         country: country.country,
//         countryCode: country.countryCode,
//         flag: country.flag,
//         timezoneOffset: country.timezoneOffset,
//         location: country.location,
//         currencySymbol: country.currencySymbol,
//         prefferedLanguage: country.prefferedLanguage,
//         currencyCode: country.currencyCode,
//       };
//     });
//   });

//    const CountryData: MenuProps['items'] = countryRegions.map((region) => ({
//     key: region.region,
//     label: region.region,
//     type: 'group',
//     children: region.countries.map((country) => ({
//       key: country.countryCode,
//       label: `${country.flag} ${country.country}`,
//     })),
    
//   }));


//   const handleSelectRegion: MenuProps['onClick'] = (info) => {
//     const selected = countryDataMap[info.key];
    
//     if (selected) {
//       setSelectedRegion({
//         country: selected.country,
//         countrycode: selected.countryCode,
//         flag: selected.flag,
//         timezoneOffset: selected.timezoneOffset,
//         location: selected.location,
//         currencySymbol: selected.currencySymbol,
//         prefferedLanguage: selected.prefferedLanguage,
//         currencyCode: selected.currencyCode
//       });
//     }
//   };

//   return (
//     <Col>
//       <Dropdown
//         menu={{
//           items: CountryData,
//           onClick: handleSelectRegion,
//           style: { maxHeight: 300, overflowY: 'auto' }
//         }}
//         trigger={['click']}
//       >
//         <Button>
//           {selectedRegion
//             ? `${selectedRegion.flag} ${selectedRegion.country}`
//             : 'Select Country'}
//         </Button>
//       </Dropdown>
//     </Col>
//   );
// };

// export default CountrySwitcher;


import { Dropdown, Button, Col } from 'antd';
import type { MenuProps } from 'antd';
import { useRegion } from '@/context/CountryContext';
import { countryRegions } from '@/pages/amazon/accounts/Data/CountryRegions';
import { useMemo, useTransition, useCallback } from 'react';

const CountrySwitcher = () => {
  const { selectedRegion, setSelectedRegion } = useRegion();
  const [isPending, startTransition] = useTransition();

  const countryDataMap = useMemo(() => {
    const map: Record<string, any> = {};
    countryRegions.forEach(region => {
      region.countries.forEach(country => {
        map[country.countryCode] = {
          country: country.country,
          countryCode: country.countryCode,
          flag: country.flag,
          timezoneOffset: country.timezoneOffset,
          location: country.location,
          currencySymbol: country.currencySymbol,
          prefferedLanguage: country.prefferedLanguage,
          currencyCode: country.currencyCode,
        };
      });
    });
    return map;
  }, []); // Empty deps - only calculate once

  // Memoize country data menu items
  const CountryData: MenuProps['items'] = useMemo(() =>
    countryRegions.map(region => ({
      key: region.region,
      label: region.region,
      type: 'group' as const,
      children: region.countries.map(country => ({
        key: country.countryCode,
        label: `${country.flag} ${country.country}`,
      })),
    })),
    []
  );

  const handleSelectRegion: MenuProps['onClick'] = useCallback((info) => {
    const selected = countryDataMap[info.key];
    
    if (selected) {
      startTransition(() => {
        setSelectedRegion({
          country: selected.country,
          countrycode: selected.countryCode,
          flag: selected.flag,
          currencySymbol: selected.currencySymbol,
          prefferedLanguage: selected.prefferedLanguage,
          currencyCode: selected.currencyCode,
          timezone: selectedRegion.timezone,
          timezoneOffset: selectedRegion.timezoneOffset,
          location: selectedRegion.timezone,
          timezoneStatus: selectedRegion.timezoneStatus,
        });
      });
    }
  }, [countryDataMap, selectedRegion, setSelectedRegion]);

  return (
    <Col>
      <Dropdown
        menu={{
          items: CountryData,
          onClick: handleSelectRegion,
          style: { maxHeight: 300, overflowY: 'auto' }
        }}
        trigger={['click']}
      >
        <Button loading={isPending}>
          {selectedRegion
            ? `${selectedRegion.flag} ${selectedRegion.country}`
            : 'Select Country'}
        </Button>
      </Dropdown>
    </Col>
  );
};

export default CountrySwitcher;